'use strict';
(function () {
    App.controller('LifeDetailsCtrl', lifeDetailsCtrl);

    lifeDetailsCtrl.$inject = ['$scope', '$stateParams', '$timeout', '$state', 'profileService', '$rootScope'];

    function lifeDetailsCtrl($scope, $stateParams, $timeout, $state, profileService, $rootScope) {
        $scope.page = 'insurance';
        $scope.$emit('page', $scope.page);

        $scope.step = 'Moja deklaracja';
        $scope.$emit('step', $scope.step);

        $scope.link = 'root.life.list';
        $scope.$emit('link', $scope.link);

        // Determine if user is logged in;
        if (window.sessionStorage.getItem('userObject')) {
            $scope.userObject = angular.fromJson(window.sessionStorage.getItem('userObject'));
        } else {

        }

        // Get package data;
        (function () {
            if (!$stateParams.package) {
                $state.go('root.life.list', angular.extend($stateParams), {inherit: false});
            }
            $scope.data = $stateParams.package;
        })();

        $scope.bankAccountNumber = null;
        profileService.getBankAccountNumber('LIFE_INSURANCE').then(function (success) {
            if(success.data){
                $scope.bankAccountNumber = success.data['accountNumber'];
            }
        });

        $scope.partnerAdditionalFields = [];
        if ($rootScope.CONFIGURATOR.lifeInsurance.isBirthPlaceOfPartnerEnabled) {
            $scope.partnerAdditionalFields.push('birthplace');
        }

        $scope.documents = function () {
            $state.go('root.life.document', {
                person: $stateParams.person,
                persons: $stateParams.persons,
                choose: $stateParams.choose,
                prices: $stateParams.prices,
                partner: $stateParams.partner,
                assured: $stateParams.assured,
                summary: $stateParams.summary,
                isAssured: $stateParams.isAssured,
                isPartner: $stateParams.isPartner,
                saveResponse: $stateParams.saveResponse
            });
        };

        $scope.incident = function () {
            $state.go('root.life.incident', {
                person: $stateParams.person,
                persons: $stateParams.persons,
                choose: $stateParams.choose,
                prices: $stateParams.prices,
                partner: $stateParams.partner,
                assured: $stateParams.assured,
                summary: $stateParams.summary,
                isAssured: $stateParams.isAssured,
                isPartner: $stateParams.isPartner,
                saveResponse: $stateParams.saveResponse
            });
        };

        $scope.related = function () {
            $state.go('root.life.related', angular.extend($stateParams, {
                declarationEntity: $stateParams.package
            }));
        }
    }
})();
